export enum LocalStorageKeysEnum {
  token = 'token',
}
